import AvailbleCard from '@common/cards/AvailbleCard';
import { company } from '@components/config/Company';
import Link from 'next/link';
import React from 'react';

function ContentDiv() {
  return (
    <div>
      <div className="flex flex-col items-start justify-between gap-5 lg:flex-row lg:gap-20">
        <div>
          <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
            Birmingham Airport Transfer – Are you looking for airport transfers
            to Birmingham Airport BHX?
          </div>
          <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            Need a reliable airport transfer service in Birmingham? Look no
            further than 24/7 Radio Carz! As the city’s largest private hire
            vehicle company, we offer round-the-clock rides to and from
            Birmingham Airport (BHX). With the biggest fleet of private hire
            vehicles at your disposal, you can count on us for a stress-free
            start or end to your trip.
            <br />
            <br />
            Travelling abroad, whether for leisure or work, can be needlessly
            stressful. Between packing, exchanging money, securing travel
            insurance, and coordinating logistics, it's all too easy to succumb
            to anxiety and panic.
            <br />
            <br />
            Traveling to Birmingham International Airport? Let 247 Cars take the
            hassle out of your journey.
            <br />
          </div>
        </div>
        <div className="w-[100%]">
          <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
            Book Online
          </div>
          <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            To get an online quote and make a booking please use the ‘
            <Link href="/">
              <a className="font-normal text-secondary hover:underline">
                Book Online Now
              </a>
            </Link>
            ‘ page. Simply enter the pick up location i.e
            <b>Birmingham Airport BHX</b> and choose your airport from the list
            that appears or for a local address enter the post code for the
            location. Click ‘<b>Estimate Cost / Book!</b>’ and you will be
            presented with a quote estimate for the different vehicles
            available. Choose the one that you require and enter the information
            required. We will email you a confirmation once this is completed.{' '}
            <br />
            <br />
            From the minute you get in touch with us, we will do all we can to
            ensure that your booking and transfer go as easily as possible with
            247 Cars.
            <br />
            <br />
          </div>
        </div>
      </div>
      <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
        Birmingham Airport Taxis
      </div>
      <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
        Are you looking for a friendly, efficient and professional taxi service
        from Birmingham International Airport? We have the largest fleet of
        Private Hire Vehicles in Birmingham with a dedicated network of drivers
        on standby for a taxi service to and from Birmingham Airport. Our team
        of friendly drivers aim to deliver a first class service to ensure your
        journey to and from Birmingham Airport is enjoyable and stress free.
        <br />
        <br />
        Our drivers are familiar with all terminals, drop-off and pick-up areas
        within the Birmingham Airport grounds to ensure an efficient and stress
        free journey with us.
        <br />
        <br />
      </div>
      <AvailbleCard />
      <div className="flex flex-col items-start justify-between gap-5 lg:flex-row lg:gap-20">
        <div className="w-[100%]">
          <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
            Taxi Birmingham Airport
          </div>
          <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            Are you looking for a transfer from your home, hotel or place of
            work to Birmingham Airport? By pre-booking one of our Private Hire
            Vehicles you can ensure your journey to BHX is as stress free as
            possible. Our drivers have the experience necessary to ensure you
            are dropped at the correct terminal in a efficient and timely
            manner.
            <br />
            <br />
            <b>Need help with your luggage?</b> We can accommodate up to 7
            passengers for larger groups of travellers, with assisted luggage
            loading and unloading at both pick-up and drop-off location.
            Pre-book your taxi to Birmingham Airport early to ensure there is
            plenty of time between your check in and departure.
          </div>
        </div>
        <div className="w-[100%]">
          <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
            Local knowledge of Birmingham and the surrounding areas
          </div>
          <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            Maybe you are visiting Birmingham or the surrounding areas and are
            looking for local insight for the{' '}
            <b>
              best places to eat, points of interest, hotels and attractions?
            </b>
            <br />
            <br />
            Our drivers are at hand to ensure your stay in Birmingham is a
            pleasant one. We are proud of our city and our drivers can assist
            with sharing their knowledge of the local areas, and of course our
            drivers can be pre-booked for further trips in and around Birmingham
            and the surrounding areas.
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start justify-between gap-5 lg:flex-row lg:gap-20">
        <div className="w-[100%]">
          <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
            Taxi from Birmingham Airport to Coventry
          </div>
          <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            With our Airport based toward the east of Birmingham the closest
            City to Birmingham Airport is in fact Coventry. With Coventry being
            just a short trip from the Airport and NEC/LG Arena (approximately
            11 miles) our drivers have knowledge of the local area to ensure
            your journey is efficient and stress free.
            <br />
            <br />
            Whether you are looking for a taxi service from Birmingham Airport
            to Coventry Train Station, Coventry Coach Station or one of the many
            points of interest including the Ricoh Arena, then 24/7 Cars have
            got it covered.
            <br />
            <br />
            As always our drivers are at hand to assist with getting your
            luggage in and out of our vehicles safely.
            <br />
            <br />A pre-booked taxi service from Birmingham Airport to Coventry
            needn’t be a stressful one, simply call us on{' '}
            <Link href={`tel:${company[0]?.tel_number_two}`}>
              <a className="font-light text-secondary hover:underline">
                {company[0]?.tel_number_two}
              </a>
            </Link>
            or
            <Link href="/">
              <a className="font-light text-secondary hover:underline">
                click here
              </a>
            </Link>
            to book online immediately.
            <br />
            <br />
            <div className="mt-5 font-normal text-gray text-base sm:text-lg lg:text-xl 2xl:text-2xl">
              Typical cost of Taxi from Birmingham Airport to Coventry: *
            </div>
          </div>
        </div>
        <div className="w-[100%]">
          <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
            Taxi from Birmingham Airport to Wolverhampton
          </div>
          <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            The City of Wolverhampton is based some 17 miles North West of
            Birmingham Airport with typical journey times of around 35-40
            minutes. Pre-book your taxi with 24/7 Cars to ensure a fully insured
            Private Hire Vehicle is waiting for you upon arrival in the
            passenger pick-up area of Birmingham Airport.
            <br />
            <br />
            Our drivers are hand to ensure help with loading and unloading your
            luggage and have knowledge of the local areas should you wish to
            stop for refreshments en-route. Whether you are require a taxi from
            Birmingham Airport to Wolverhampton Train Station, Wolverhampton
            Hotels or points of interest such as the Wolverhampton Art Gallery
            and Theatres then 24/7 Cars have got it covered.
            <br />
            <br />
            For a safe and efficient taxi service from Birmingham Airport to
            Wolverhampton simply call us on
            <Link href={`tel:${company[0]?.tel_number_two}`}>
              <a className="font-light text-secondary hover:underline">
                {company[0]?.tel_number_two}
              </a>
            </Link>
            or
            <Link href="/">
              <a className="font-light text-secondary hover:underline">
                click here
              </a>
            </Link>
            to make your online booking today.
          </div>

          <div className="mt-5 font-normal text-gray text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            Typical cost of Taxi from Birmingham Airport to Wolverhampton: *
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start justify-between gap-5 lg:flex-row lg:gap-20">
        <div className="w-[100%]">
          <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
            Taxi from Birmingham Airport to Derby
          </div>
          <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            Derby is some 40 miles North of Birmingham Airport and is accessible
            via the A38 or M1 motorway with a journey time of around 1 hour. Our
            drivers have extensive experience of the UK motorway network to
            ensure your journey is safe and efficient. Use our drivers inside
            knowledge of the local areas to help with refreshments en route and
            details of the attractions and points of interest.
            <br />
            <br />
            Whether you are looking to travel from Birmingham Airport to Derby
            Train Station, Derby Coach Station or any other point of interest
            including Pride Park Football Stadium, 24/7 cars have you covered.
            <br />
            <br />
            <b>Be booked, Be Insured!</b> Pre-book your Private Hire Taxi with
            us and ensure complete safety and peace of mind for you and your
            passengers. We understand that after a long flight you need a
            professional and efficient service to get you to your destination in
            comfort.
            <br />
            <br />
            Our drivers are hand to help with loading your luggage in and our of
            the vehicle and will be waiting in the pick-up area of Birmingham
            Airport ready for your arrival.
            <br />
            <br />
            Please call{' '}
            <Link href={`tel:${company[0]?.tel_number_two}`}>
              <a className="font-light text-secondary hover:underline">
                {company[0]?.tel_number_two}
              </a>
            </Link>{' '}
            to pre-book your taxi or{' '}
            <Link href="/">
              <a className="font-light text-secondary hover:underline">
                click here
              </a>
            </Link>{' '}
            to book online.
            <br />
            <br />
          </div>
          <div className="mt-5 font-normal text-gray text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            Typical cost of Taxi from Birmingham Airport to Derby: *
          </div>
        </div>
        <div className="w-[100%]">
          <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
            Taxi from Birmingham Airport to Leicester
          </div>
          <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            With the expansion of the Birmingham Airport runway and terminals
            there is an ever increasing number of domestic and international
            flights now coming in and out of this West Midlands Hub of sorts.
            With ever increasing demand we now offer a transfer service from
            Birmingham Airport to Leicester and the surrounding areas.
            <br />
            <br />
            Leicester is some 35 miles East of Birmingham Airport and accessible
            via a number of routes including the M6 and M69 motorway. Our
            drivers have extensive knowledge of the UK motorway network to
            ensure a safe and comfortable journey with us.
            <br />
            <br />
            Tap in to our drivers knowledge of the local areas for points of
            interest, local attractions and places to eat. We aim to provide an
            unrivalled service, our drivers are at hand to help with loading
            your luggage in and out of vehicles and will be waiting in the
            pick-up area of the Birmingham Airport grounds.
            <br />
            <br />
            By pre-booking a Private Hire Taxi you are fully insured for
            complete peace of mind for you and your party. Whether you are
            looking for a taxi to Leicester Train Station, Leicester Coach
            Station or any other point of interest including the UK’s largest
            attraction – The National Space Centre, 24/7 Cars have you covered.
            <br />
            <br />
            Please call{' '}
            <Link href={`tel:${company[0]?.tel_number_two}`}>
              <a className="font-light text-secondary hover:underline">
                {company[0]?.tel_number_two}
              </a>
            </Link>{' '}
            to pre-book your taxi or{' '}
            <Link href="/">
              <a className="font-light text-secondary hover:underline">
                click here
              </a>
            </Link>{' '}
            to book online.
            <br />
            <br />
          </div>
          <div className="mt-5 font-normal text-gray text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            Typical cost of Taxis from Birmingham Airport to Leicester: *
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start justify-between gap-5 lg:flex-row lg:gap-20">
        <div className="w-[100%]">
          <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
            Taxi from Birmingham Airport to Nottingham
          </div>
          <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            Approximately 50 miles North East of Birmingham Airport is the City
            of Nottingham, journey times from the Airport are typically around
            an hour with routes available via the M1 motorway as well as the
            M42/A42.
            <br />
            <br />
            Our drivers have extensive knowledge of the UK motorway network to
            ensure your journey with us is safe a comfortable, giving you
            complete peace of mind after your flight. We provide an unrivalled
            service for Birmingham Airport transfers to Nottingham and the
            surrounding areas. Our drivers are at hand to help with loading your
            luggage in and out of the vehicle and to give our passengers useful
            information on points of interest and local attractions.
            <br />
            <br />
            Whether you are travelling from Birmingham Airport to Nottingham
            Train Station, Nottingham Coach Station or any other point of
            interest including Nottingham Castle and Sherwood Forest, 24/7 Cars
            have you covered.
            <br />
            <br />
            Be Booked, Be Insured! When you pre-book your Private Hire Taxi from
            24/7 Cars you are ensuring the safety of you and your party. Call us
            on{' '}
            <Link href={`tel:${company[0]?.tel_number_two}`}>
              <a className="font-light text-secondary hover:underline">
                {company[0]?.tel_number_two}
              </a>
            </Link>{' '}
            and book your taxi today, or{' '}
            <Link href="/">
              <a className="font-light text-secondary hover:underline">
                click here
              </a>
            </Link>{' '}
            to make a booking online.
            <br />
            <br />
          </div>
          <div className="mt-5 font-normal text-gray text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            Typical cost of Taxis from Birmingham Airport to Nottingham: *
          </div>
        </div>
        <div className="w-[100%]">
          <div className="mt-2 mb-4 font-light lg:mt-5 text-3xl">
            Taxi from Birmingham Airport to Birmingham City Centre
          </div>
          <div className="font-thin leading-8 text-justify text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            With the largest fleet of vehicles available for transfers from
            Birmingham Airport to Birmingham City Centre, we are without doubt
            the number one choice for a efficient and comfortable journey.
            <br />
            <br />
            Birmingham City Centre is approximately 14 miles from the Airport
            with journey times at around 20 mins each way. Birmingham is a
            24-hour city and 24/7 Cars are here to ensure you have a taxi
            available all year round without without compromise on service. Our
            drivers are hand to share knowledge of the local area, points of
            interest, places to stay and places to eat.
            <br />
            <br />
            Be Booked, Be Insured! Ensure the safety of you and your party by
            pre-booking a Private Hire Taxi from Birmingham Airport. 24/7 Care
            are familiar with the Airport grounds and can pick up from a number
            of points including local hotels and restaurants. Of course, our
            drivers are always available for a pre-booked journey to other
            destinations within the Birmingham area including Solihull and
            Sutton Coldfield.
            <br />
            <br />
            We offer a taxi from Birmingham Airport to a number of loBirmibgham
            City Centre attractions include the Birmingham Sea Life Centre, The
            National Indoor Arena, Hippodrome Theatre and the busy nightlife of
            Broad Street and Arcadian Centre. We also offer a direct taxi
            service to all hotels around the city including the 4* Hyatt Hotel
            and Marriott Hotel Birmingham.
            <br />
            <br />
            Pre-book your taxi from Birmingham Airport to Birmingham city by
            calling us on{' '}
            <Link href={`tel:${company[0]?.tel_number_two}`}>
              <a className="font-light text-secondary hover:underline">
                {company[0]?.tel_number_two}
              </a>
            </Link>{' '}
            or simply{' '}
            <Link href="/">
              <a className="font-light text-secondary hover:underline">
                click here
              </a>
            </Link>{' '}
            to make a booking online.
            <br />
            <br />
          </div>
          <div className="mt-5 font-normal text-gray text-base sm:text-lg lg:text-xl 2xl:text-2xl">
            Typical cost of Taxi from Birmingham Airport to Birmingham City
            Centre: *
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContentDiv;
